import React from "react";
import ChoiceStep from "./ChoiceStep";
import NpsStep from "./NpsStep";
import OpenQuestionStep from "./OpenQuestionStep";
import { useSurvey } from "./SurveyContext";

export default function QuestionStep() {
  const { flow, otherLabel, otherTextMax, saver, submit: onSubmit } = useSurvey();
  const { question, response, updateResponse: onUpdate } = flow;
  const { failed, submitting } = saver;
  const canGoBack = flow.stepIndex > 0;
  const onBack = flow.back;
  const options = flow.orderedOptions[question.identifier];

  if(question.type === "nps") {
    return (
      <NpsStep
        failed={failed}
        onSelect={(score) => onSubmit({ ...response, score })}
        question={question}
        score={response.score}
        submitting={submitting}
      />
    );
  }

  if(question.type === "open") {
    const canContinue = !question.mandatory || response.text.trim().length >= (question.minLength || 1);
    return (
      <OpenQuestionStep
        canContinue={canContinue}
        canGoBack={canGoBack}
        failed={failed}
        onBack={onBack}
        onContinue={() => onSubmit(response)}
        onSkip={() => onSubmit({ ...response, text: "" })}
        onTextChange={(text) => onUpdate({ text })}
        question={question}
        submitting={submitting}
        text={response.text}
      />
    );
  }

  const otherGiven = response.otherChecked && response.otherText.trim().length > 0;
  const selectionCount = response.answers.length + (otherGiven ? 1 : 0);
  // A ticked but empty "other" still takes up one of the max choices, otherwise
  // typing into it later can push the answer over the limit.
  const claimedCount = response.answers.length + (response.otherChecked ? 1 : 0);

  const toggleOption = (option) => {
    const answers = response.answers.includes(option)
      ? response.answers.filter((answer) => answer !== option)
      : response.answers.concat([option]);
    onUpdate({ answers });
  };

  return (
    <ChoiceStep
      answers={response.answers}
      canContinue={!question.mandatory || selectionCount > 0}
      canGoBack={canGoBack}
      failed={failed}
      onBack={onBack}
      onContinue={() => onSubmit(response)}
      onOtherTextChange={(otherText) => onUpdate({ otherText })}
      onToggleOption={question.multiple ? toggleOption : (option) => onSubmit({ ...response, answers: [option] })}
      onToggleOther={() => onUpdate({ otherChecked: !response.otherChecked, otherText: "" })}
      options={options}
      otherChecked={response.otherChecked}
      otherLabel={otherLabel}
      otherText={response.otherText}
      otherTextMax={otherTextMax}
      question={question}
      selectionCount={claimedCount}
      submitting={submitting}
    />
  );
}
